var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { default as axios } from "axios";
import { compose, withHandlers, withState } from "recompose";
import { withNotification, withSession } from "enhancers";
import { NotificationType } from "providers/store/notification";
export var withFormSubmit = function (_a) {
    var _b = _a === void 0 ? {} : _a, target = _b.target, message = _b.message, authorize = _b.authorize;
    return compose(withNotification(), withSession(), withState("form", "setForm", function () { return ({
        pending: false,
        success: false
    }); }), withHandlers({
        submit: function (_a) {
            var setForm = _a.setForm, displayNotification = _a.displayNotification, dismissNotification = _a.dismissNotification, session = _a.session;
            return function (request) { return __awaiter(void 0, void 0, void 0, function () {
                var url, response, err_1, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/" + window.env.API_BASE_PATH + "/" + (target || location.pathname).replace(/^\//, "");
                            setForm({ pending: true, success: false });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            dismissNotification();
                            return [4, axios.post(url, __assign(__assign({}, request), { tenant: window.env.TENANT }) || {}, {
                                    withCredentials: true,
                                    headers: __assign({ "Content-Type": "application/json" }, (authorize && session
                                        ? { Authorization: "Bearer " + session.access.token }
                                        : {}))
                                })];
                        case 2:
                            response = (_a.sent()).data;
                            setForm({ pending: false, success: true, response: response });
                            if (message) {
                                displayNotification({
                                    type: NotificationType.SUCCESS,
                                    message: message
                                });
                            }
                            return [3, 4];
                        case 3:
                            err_1 = _a.sent();
                            response = err_1.response;
                            displayNotification({
                                type: NotificationType.ERROR,
                                message: (response && response.data && response.data.message) || "request_error"
                            });
                            setForm({ pending: false, success: false, err: err_1 });
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
        }
    }));
};
